<ng-container *transloco="let t">
    <app-admin-modal-layout
            [title]="'league.competitors.match.details.title'"
            (onClose)="onClose()"
            (onSave)="onConfirm()"
            [saveDisabled]="saveDisabled"
    >
        <div class="pb-4">
            <!-- Current Competitor -->
            <div class="fs-11 fw-500 text-uppercase color-grey-neutral-700 background-grey-neutral-50 ps-3 py-1 border-bottom">{{ t('league.competitors.match.competitor') }}</div>
            <ng-container *ngTemplateOutlet="competitorRow; context: { $implicit: matchingData?.competitor, showActions: false }"/>

            <!-- Matched To -->
            <div class="fs-11 fw-500 text-uppercase color-grey-neutral-700 background-grey-neutral-50 ps-3 py-1 border-bottom mt-3">{{ t('league.competitors.match.matched.to') }}</div>
            @if (matchingData?.matchedTo) {
            <ng-container *ngTemplateOutlet="competitorRow; context: { $implicit: matchingData!.matchedTo, showActions: true }"/>
            } @else {
            <div class="fs-12 color-400 ps-3 py-1">{{ t('league.competitors.match.to.not.matched') }}</div>
            }

            <!-- Matched From -->
            <div class="fs-11 fw-500 text-uppercase color-grey-neutral-700 background-grey-neutral-50 ps-3 py-1 border-bottom mt-3">{{ t('league.competitors.match.matched.from') }}</div>
            <div class="scrollable">
                @if (matchingData?.matchedFrom?.length) {
                @for (c of matchingData!.matchedFrom; track c.id) {
                <ng-container *ngTemplateOutlet="competitorRow; context: { $implicit: c, showActions: true }"/>
                }
                } @else {
                <div class="fs-12 color-grey-neutral-400 ps-3 py-1">{{ t('league.competitors.match.from.not.matched') }}</div>
                }
            </div>
        </div>

        <ng-template #competitorRow let-c let-showActions="showActions">
            <div class="competitor-grid border-bottom">
            <div class="d-flex flex-column gap-6">
                <div class="flex-base">
                        <span class="fs-13 fw-600 color-grey-neutral-900">{{ c?.firstName }} {{ c?.lastName }}</span>
                        <span class="fs-11 color-grey-neutral-400">ID {{ c?.id }}</span>
                </div>

                <div class="d-flex align-items-start gap-32">
                    <div class="d-flex flex-column gap-2">
                        <span class="fs-10 color-grey-neutral-500">{{ t('app.common.birthDay') }}</span>
                        <span class="fs-12 fw-500 color-grey-neutral-700">{{ c?.birthday ?? '' | localizedDate:'shortDate' }}</span>
                    </div>
                    <div class="d-flex flex-column gap-2">
                        <span class="fs-10 color-grey-neutral-500">{{ t('app.common.gender') }}</span>
                        <span class="fs-12 fw-500 color-grey-neutral-700">{{ c?.sex ? t('app.common.gender.short.' + c.sex) : '-' }}</span>
                    </div>
                    <div class="d-flex flex-column gap-2">
                        <span class="fs-10 color-grey-neutral-500">{{ t('app.common.country') }}</span>
                        <span class="fs-12 fw-500 color-grey-neutral-700">{{ c?.country ? (c.country | country) : '-' }}</span>
                    </div>
                    <div class="d-flex flex-column gap-2">
                        <span class="fs-10 color-grey-neutral-500">{{ t('app.common.category') }}</span>
                        <span class="fs-12 fw-500 color-grey-neutral-700">{{ c?.categoryItemLabel ?? '-' }}</span>
                    </div>
                </div>

                <div class="flex-base">
                    <span class="fs-10 color-grey-neutral-500">{{ t('app.common.races') }}</span>
                    @if (c?.rounds?.length) {
                    <div class="d-flex flex-wrap gap-4">
                        @for (race of c.rounds; track race.id) {
                            <div class="status-badge orange">
                                <span class="pe-2">{{race.id}}</span>
                                <span class="pe-2">-</span>
                                <span class="fw-500">{{raceNames.get(race.id!)}}</span>
                            </div>
                    }
                    </div>
                    } @else {
                    <span class="fs-12 fw-500 color-grey-neutral-700">-</span>
                    }
                </div>

            </div>
             <div class="d-flex justify-content-between align-items-end flex-column">
                     <div>
                         @if (c.matchStatus) {
                         <div class="status-badge"
                              [class.green]="c.matchStatus === MatchStatus.FULL_MATCH"
                              [class.blue]="c.matchStatus === MatchStatus.MERGED"
                              [class.gray]="c.matchStatus === MatchStatus.DUPLICATE"
                              [class.gray-bck-blue-clr]="c.matchStatus === MatchStatus.MERGED_DUPLICATE"
                        >
                         <span class="fw-500">
                             {{ t('league.competitor.match.status.' + c.matchStatus) | uppercase}}
                         </span>
                         </div>
                         }

                     </div>
                     @if (showActions) {
                     <div class="d-flex align-items-center">
                           <span class="fs-12 fs-10 color-grey-neutral-500">
                            {{ t('league.competitor.match.unlink')}}
                            </span>
                             <div class="form-check form-switch">
                               <input class="form-check-input switch"
                               [checked]="selectionMap.get(c!.id!)"
                               (change)="onUnlink(c!.id!)"
                               type="checkbox">
                             </div>
                         </div>
                     }
            </div>
            </div>
        </ng-template>
    </app-admin-modal-layout>
</ng-container>